<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-toolbar flat outlined>
            <v-btn icon :link="false" @click="back">
                <v-icon>fa-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
            <v-spacer/>
            <v-btn color="primary" @click="send_form" :disabled="disabled_guardar">
              Guardar
            </v-btn>
  </v-toolbar>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alertDialog"
        :type="alertDialogType"
        outline
      >
        {{ alertDialogMessage }}
      </v-alert>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos Personales</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm3 md3 style="display: none">
                <v-text-field
                  disabled
                  v-model="domestico_id"
                  label="id"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="nombres"
                  label="Nombre(s)"
                  :rules="text_required_rules"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="apellido_paterno"
                  label="Primer Apellido"
                  :rules="text_required_rules"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="apellido_materno"
                  label="Segundo Apellido"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select class="my-0 py-0"
                  v-model="sexo"
                  label="Sexo"
                  :items="tipo_sexo"
                />
              </v-flex>
              <FechaPicker
                v-model="fecha_nacimiento"
                label="Fecha Nacimiento"
                :clase="'my-0 py-0'">
              </FechaPicker>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="nacionalidad"
                  label="Nacionalidad"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="originario"
                  label="Originario"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="curp"
                  label="CURP"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="estado_civil"
                  label="Estado Civil"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="rfc"
                  label="RFC"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="n_seguridad_social"
                  label="Núm. SS"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="domicilio"
                  label="Domicilio"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="colonia"
                  label="Colonia"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="localidad"
                  label="Localidad"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="estado"
                  label="Estado"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="codigo_postal"
                  label="Código Postal"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="telefono"
                  label="Teléfono"
                  type="number"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="celular"
                  label="Celular"
                  type="number"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>En caso de emergencia avisar a</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field class="my-0 py-0"
                  v-model="emergencia_nombre"
                  label="Nombre Completo"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="emergencia_parentesco"
                  label="Parentesco"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="emergencia_telefono"
                  label="Celular"
                  type="number"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Atributos del Personal</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field class="my-0 py-0"
                  v-model="puesto"
                  label="Puesto/Actividad"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select class="my-0 py-0"
                  v-model="status"
                  label="Estatus"
                  :items="tipo_status"
                  @change="tipo_status_change($event)"
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-textarea class="my-0 py-0"
                  v-model="motivo_baja"
                  :value="motivo_baja"
                  :disabled="motivo_disabled"
                  label="Motivo de Baja"
                  no-resize
                  rows="1"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Uso Autorizado de</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-checkbox class="my-0 py-0"
                  v-model="carrito_golf"
                  label="Carrito de Golf"
                  @change="clear_input('carrito_golf')"
                />
              </v-flex>
              <v-flex xs12 sm10 md10>
                <v-text-field class="my-0 py-0"
                  v-model="carrito_golf_detalles"
                  label=""
                  :disabled="!carrito_golf"
                />
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-checkbox class="my-0 py-0"
                  v-model="vehiculo_residente"
                  label="Vehículo Residente"
                  @change="clear_input('vehiculo_residente')"
                />
              </v-flex>
              <v-flex xs12 sm10 md10>
                <v-text-field class="my-0 py-0"
                  v-model="vehiculo_residente_detalles"
                  label=""
                  :disabled="!vehiculo_residente"
                />
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-checkbox class="my-0 py-0"
                  v-model="vehiculo_particular"
                  label="Vehículo Particular"
                  @change="clear_input('vehiculo_particular')"
                />
              </v-flex>
              <v-flex xs12 sm10 md10>
                <v-text-field class="my-0 py-0"
                  v-model="vehiculo_particular_detalles"
                  label=""
                  :disabled="!vehiculo_particular"
                />
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-checkbox class="my-0 py-0"
                  v-model="bicicleta"
                  label="Bicicleta"
                  @change="clear_input('bicicleta')"
                />
              </v-flex>
              <v-flex xs12 sm10 md10>
                <v-text-field class="my-0 py-0"
                  v-model="bicicleta_detalles"
                  label=""
                  :disabled="!bicicleta"
                />
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-checkbox class="my-0 py-0"
                  v-model="motocicleta"
                  label="Motocicleta"
                  @change="clear_input('motocicleta')"
                />
              </v-flex>
              <v-flex xs12 sm10 md10>
                <v-text-field class="my-0 py-0"
                  v-model="motocicleta_detalles"
                  label=""
                  :disabled="!motocicleta"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos del Empleador</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-combobox class="my-0 py-0"
                  v-model="vivienda_asoc"
                  label="Vivienda"
                  placeholder="Comience a escribir para buscar"
                  :items="viviendas"
                  :loading="viviendaIsLoading"
                  :search-input.sync="viviendaSearch"
                  :hide-no-data="!viviendaSearch"
                  item-text="n_vivienda"
                  item-value="n_vivienda"
                  return-object
                  @change="vivienda_asoc_change($event)"
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select class="my-0 py-0"
                  v-model="residentes_asoc"
                  label="Residentes"
                  placeholder = "Seleccione un residente titular"
                  no-data-text = "Vivienda sin residentes"
                  :items="residentes"
                  :disabled="residente_disabled"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Condiciones de Acceso</strong>
                <v-divider/>
              </v-flex>
              <FechaPicker :clase="'my-0 py-0'"
                label="Fecha de Inicio"
                v-model="fecha_inicio"
                :birthdayPicker="false"
                :size="'6'"
                :disable="residente_acceso_disabled"
                :rules="residente_acceso_disabled ? [] : accesoMultipleRules"
              >
              </FechaPicker>
              <FechaPicker :clase="'my-0 py-0'"
                v-model="fecha_fin"
                label="Vigente Hasta"
                :birthdayPicker="false"
                :size="'6'"
                :min_date="this.fecha_inicio"
                :max_date="set_add_date(this.fecha_inicio,1, 'years')"
                :disable="residente_acceso_disabled"
                :rules="residente_acceso_disabled ? [] : accesoMultipleRules"
              >
              </FechaPicker>
              <v-flex xs12 sm12 md12>
                <v-select class="my-0 py-0"
                  v-model="selected_acceso_dias"
                  :items="acceso_dias"
                  label="Días Permitidos"
                  :disabled="residente_acceso_disabled"
                  :rules="residente_acceso_disabled ? [] : selectMultipleRules"
                  multiple
                  chips
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-select class="my-0 py-0"
                  v-model="tipo_horario"
                  label="Horario"
                  :items="tipo_acceso"
                  @change="tipo_acceso_change($event)"
                  :disabled="residente_acceso_disabled"
                />
              </v-flex>
              <HoraPicker
                v-model="hora_entrada"
                :label="'Hora Entrada'"
                :disable="tipo_acceso_disabled"
                :rules="tipo_acceso_disabled ? [] : selectMultipleRules"
                :size="'4'"
                :clase="'my-0 py-0'"
                :format="'24hr'"
              />
              <HoraPicker
                v-model="hora_salida"
                :label="'Hora Salida'"
                :disable="tipo_acceso_disabled"
                :rules="tipo_acceso_disabled ? [] : selectMultipleRules"
                :size="'4'"
                :clase="'my-0 py-0'"
                :format="'24hr'"
                :min_time="set_min_time(this.hora_entrada)"
              />
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Dispositivos Biométricos</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select class="my-0 py-0"
                  v-model="selected_faciales"
                  :items="faciales_proveedores"
                  label="Portico Proveedores"
                  multiple
                  chips
                  />
              </v-flex>
              <!--
              <v-flex xs12 sm6 md6>
                <v-select class="my-0 py-0"
                  v-model="selected_faciales"
                  :items="faciales_principal"
                  label="Portico Principal"
                  multiple
                  chips
                  />
              </v-flex>
              -->
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Fotos</strong>
                <v-divider/>
              </v-flex>
              <FotoSubir v-model="domestico_image" :label="'Foto Personal Doméstico'" :value="''"
                :size="'3'" :idImg="'imgRostro'" :idInput="'inputRostro'"
                :idProgress="'progressRostro'" :colorProgress="this.colorProgress"
                :textProgress="this.textProgress" :styleProgress="this.styleProgress"
                v-if="this.rostro === ''"/>
              <FotoSubir v-model="domestico_image" :label="'Foto Personal Doméstico'" :value="''"
                :size="'3'" :idImg="'imgRostro'" :idInput="'inputRostro'"
                :idProgress="'progressRostro'" :colorProgress="this.colorProgress"
                :textProgress="this.textProgress" :styleProgress="this.styleProgress" v-else/>
                <v-btn color="primary" @click="check_image">
                  Validar
                </v-btn>
              <FotoSubir v-model="ine_frente" :label="'Foto INE (frente)'" :value="''"
                :size="'4'" :idImg="'imgIneFrente'"/>
              <FotoSubir v-model="ine_reverso" :label="'Foto INE (reverso)'" :value="''"
                :size="'4'" :idImg="'imgIneReverso'"/>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Aviso de Privacidad</strong>
                <v-divider/>
              </v-flex>
              <embed src="files/privacidad.pdf" type="application/pdf"
                width="100%" height="600px"/>
              <firma v-model="firma_residente" :text_label="'Firma Residente'"
                :id_canvas="'idResidente'" :name_form="'formResidente'"
                :name_sigraw="'sigRawResidente'" :name_sigimg="'sigImgResidente'">
              </firma>
              <firma v-model="firma_domestico" :text_label="'Firma Servicio Doméstico'"
                :id_canvas="'idDomestico'" :name_form="'formDomestico'"
                :name_sigraw="'sigRawDomestico'" :name_sigimg="'sigImgDomestico'">
              </firma>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import FechaPicker from '@/components/fecha_picker.vue';
import HoraPicker from '@/components/hora_picker.vue';
import FotoSubir from '@/components/foto_subir.vue';
import Firma from '@/components/firma.vue';
import moment from '../../node_modules/moment';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

export default {
  components: {
    FechaPicker,
    HoraPicker,
    FotoSubir,
    Firma,
  },
  data: () => ({
    domestico_image: '',
    domestico_info: {},
    totalItems: 0,
    domesticos: [],
    pagination: {},
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    infodialog: false,
    headers: [
      { text: 'Nombre(s)', value: 'primer_nombre', sortable: true },
      { text: 'Primer Apellido', value: 'primer_apellido', sortable: true },
      { text: 'Segundo Apellido', value: 'segundo_apellido', sortable: true },
      { text: 'Vivienda', value: 'vivienda', sortable: true },
      { text: 'Residente Responsable', value: 'residente', sortable: true },
      { text: 'Estatus', value: 'status', sortable: true },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    tipo_status: [
      { text: 'Inactivo', value: 'inactivo' },
      { text: 'Activo', value: 'activo' },
    ],
    tipo_sexo: [
      { text: 'Masculino', value: 'M' },
      { text: 'Femenino', value: 'F' },
    ],
    tipo_acceso: [
      { text: 'Todo el día', value: '1' },
      { text: 'Especifico', value: '0' },
    ],
    acceso_dias: [
      { text: 'Lunes', value: 'lunes' },
      { text: 'Martes', value: 'martes' },
      { text: 'Miércoles', value: 'miercoles' },
      { text: 'Jueves', value: 'jueves' },
      { text: 'Viernes', value: 'viernes' },
      { text: 'Sábado', value: 'sabado' },
      { text: 'Domingo', value: 'domingo' },
    ],
    faciales_proveedores: [
      { text: 'Proveedores Peatonal', value: 'proveedores_peatonal' },
      { text: 'Proveedores Vehicular', value: 'proveedores_vehicular' },
    ],
    faciales_principal: [
      { text: 'Visitantes Principal', value: 'principal_visitantes' },
      { text: 'Residentes Principal', value: 'principal_residentes' },
    ],
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    emailRules: [
      v => !!v || 'Correo electrónico requerido',
      v => /.+@.+/.test(v) || 'Correo electrónico no válido',
    ],
    rfcRules: [
      v => !!v || 'Requerido',
      v => /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/.test(v) || 'RFC no válido',
    ],
    codigoPostalRules: [
      v => !!v || 'Requerido',
      v => /^([0-9]{5,6})$/.test(v) || 'Código postal de 5 a 6 dígitos',
    ],
    phoneRules: [
      v => !!v || 'Requerido',
      v => (v && v.length === 10) || 'Número de 10 dígitos',
    ],
    imgRules: [
      v => !v || v.size < 2000000 || 'La imagen debe de ser menor a 2MB',
    ],
    accesoMultipleRules: [
      v => !!v || 'Requerido',
    ],
    selectMultipleRules: [
      v => v.length > 0 || 'Requerido',
    ],
    valid: true,
    processing: false,
    nombres: '',
    apellido_paterno: '',
    apellido_materno: '',
    sexo: '',
    fecha_nacimiento: '',
    nacionalidad: '',
    originario: '',
    curp: '',
    estado_civil: '',
    rfc: '',
    n_seguridad_social: '',
    domicilio: '',
    colonia: '',
    localidad: '',
    estado: '',
    telefono: '',
    celular: '',
    codigo_postal: '',
    emergencia_nombre: '',
    emergencia_telefono: '',
    emergencia_parentesco: '',
    puesto: '',
    status: 'inactivo',
    motivo_baja: '',
    motivo_disabled: false,
    residente_id: '',
    vivienda_id: '',
    domestico_id: '',
    ine_frente: '',
    ine_reverso: '',
    rostro: '',
    acceso: [],
    acceso_multiple: true,
    selected_acceso_dias: [],
    fecha_inicio: '',
    fecha_fin: '',
    tipo_horario: '1',
    hora_entrada: '00:00',
    hora_salida: '00:00',
    tipo_acceso_disabled: true,
    residente_acceso_disabled: true,
    viviendaIsLoading: false,
    viviendaSearch: null,
    viviendasApiResult: [],
    viviendasAsociadas: [],
    viviendaValid: false,
    vivienda_asoc: null,
    residentesApiResult: [],
    residentes_asoc: '',
    residente_disabled: true,
    editdomestico: false,
    disabled_guardar: false,
    textProgress: 'Validando...',
    styleProgress: 'display: none',
    colorProgress: 'info',
    carrito_golf: false,
    vehiculo_residente: false,
    vehiculo_particular: false,
    bicicleta: false,
    motocicleta: false,
    carrito_golf_detalles: '',
    vehiculo_residente_detalles: '',
    vehiculo_particular_detalles: '',
    bicicleta_detalles: '',
    motocicleta_detalles: '',
    selected_faciales: [],
    firma_residente: [],
    firma_domestico: [],
  }),
  computed: {
    formTitle() {
      return this.editdomestico === false ? 'Agregar Servicio Doméstico' : 'Editar Servicio Doméstico';
    },
    is_loading() {
      return this.$store.getters['capturaDomesticos/is_loading'];
    },
    colaborador_submited() {
      return this.$store.getters['capturaDomesticos/domestico_submited'];
    },
    alertType() {
      return this.$store.getters['capturaDomesticos/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['capturaDomesticos/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['capturaDomesticos/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['capturaDomesticos/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['capturaDomesticos/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['capturaDomesticos/alertDialog'];
    },
    domestico_processing() {
      return this.$store.getters['capturaDomesticos/domestico_processing'];
    },
    viviendas() {
      return this.viviendasApiResult;
    },
    residentes() {
      return this.residentesApiResult;
    },
  },
  watch: {
    domestico_processing(val) {
      this.processing = val;
    },
    viviendaSearch() {
      // Items have already been loaded
      if (this.viviendas.length > 0) return;
      // Items have already been requested
      if (this.viviendaIsLoading) return;
      this.viviendaIsLoading = true;
      ApiService.setHeader();
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          this.viviendasApiResult = data.viviendas;
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.viviendaIsLoading = false;
        });
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    set_min_time(time) {
      return moment(time, 'HH:mm').add(1, 'minutes').format('HH:mm');
    },
    set_add_date(date, add, time, formatstart = 'YYYY-MM-DD', formatresult = 'YYYY-MM-DD') {
      return moment(date, formatstart).add(add, time).format(formatresult);
    },
    reset_acceso_form() {
      this.residente_acceso_disabled = true;
      this.tipo_acceso_disabled = true;
      this.residentes_asoc = '';
      this.selected_acceso_dias = [];
      this.fecha_inicio = '';
      this.fecha_fin = '';
      this.tipo_horario = '1';
      this.hora_entrada = '00:00';
      this.hora_salida = '00:00';
    },
    clear_input(input) {
      // eslint-disable-next-line default-case
      switch (input) {
        case 'carrito_golf':
          this.carrito_golf_detalles = '';
          break;
        case 'vehiculo_residente':
          this.vehiculo_residente_detalles = '';
          break;
        case 'vehiculo_particular':
          this.vehiculo_particular_detalles = '';
          break;
        case 'bicicleta':
          this.bicicleta_detalles = '';
          break;
        case 'motocicleta':
          this.motocicleta_detalles = '';
          break;
      }
    },
    clear_null(value) {
      let tmpNull = null;
      if (typeof value === 'string') {
        if (value === 'None') {
          tmpNull = '';
        } else {
          tmpNull = value.trim();
        }
      } else if (value === null || typeof value === 'undefined') {
        tmpNull = '';
      } else {
        tmpNull = value;
      }
      return tmpNull;
    },
    change_boolean(value) {
      let tmpBool = 0;
      if (typeof value === 'boolean') {
        if (value) {
          tmpBool = 1;
        }
      } else {
        tmpBool = value;
      }

      return tmpBool;
    },
    tipo_status_change(event) {
      if (event === 'inactivo') {
        this.motivo_disabled = false;
      } else {
        this.motivo_disabled = true;
      }
    },
    tipo_acceso_change(event) {
      if (event === '0') {
        this.tipo_acceso_disabled = false;
        this.hora_entrada = '';
        this.hora_salida = '';
      } else {
        this.tipo_acceso_disabled = true;
        this.hora_entrada = '00:00';
        this.hora_salida = '00:00';
      }
    },
    vivienda_asoc_change(event) {
      this.residente_disabled = false;
      this.residentesApiResult = [];
      this.redidenteIsLoading = true;
      if (typeof event === 'object' && this.clear_null(event) !== '') {
        // console.log(event.id !== undefined);
        ApiService.setHeader();
        ApiService.query(`accesos/viviendas/${event.id}`)
          .then(({ data }) => {
            if (data.vivienda.residentes.length > 0) {
              this.residente_concat_fullname(data.vivienda.residentes);
              this.residentes_asoc = data.vivienda.residentes[0].residente_id;
              this.residente_acceso_disabled = false;
            } else {
              // console.log(data.vivienda);
              this.reset_acceso_form();
            }
          })
          .catch(({ response }) => {
            console.log(response);
            this.residente_disabled = true;
          })
          .finally(() => {
            this.redidenteIsLoading = false;
          });
      } else {
        this.residente_disabled = true;
        this.reset_acceso_form();
      }
    },
    vivienda_asoc_info(id) {
      ApiService.setHeader();
      ApiService.query(`accesos/viviendas/${id}`)
        .then(({ data }) => {
          this.vivienda_asoc = data.vivienda;
          if (data.vivienda.residentes.length > 0) {
            this.residente_concat_fullname(data.vivienda.residentes);
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.redidenteIsLoading = false;
        });
    },
    residente_concat_fullname(info) {
      info.map((value, key) => {
        this.residentesApiResult.push({
          text: `${value.residente.nombres} ${this.clear_null(value.residente.apellido_paterno)} ${this.clear_null(value.residente.apellido_materno)}`.trim(),
          value: value.residente_id,
        });
      });
    },
    residente_asoc_info(id) {
      this.residente_disabled = false;
      this.residentesApiResult = [];
      this.redidenteIsLoading = true;
      ApiService.setHeader();
      ApiService.query(`accesos/residentes/${id}`)
        .then(({ data }) => {
          this.residentes_asoc = data.residente.residente_id;
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.redidenteIsLoading = false;
        });
    },
    acceso_info(acceso) {
      this.residente_acceso_disabled = false;
      this.tipo_horario = this.change_boolean(acceso.acceso_todo_dia).toString();
      if (this.tipo_horario === '0') {
        this.tipo_acceso_disabled = false;
      }
      this.hora_entrada = this.formatter_time(acceso.hora_desde);
      this.hora_salida = this.formatter_time(acceso.hora_hasta);
      this.acceso_multiple = acceso.acceso_multiple;
      this.fecha_inicio = this.formatter_date(acceso.vigente_desde, 'YYYY-MM-DD');
      this.fecha_fin = this.formatter_date(acceso.vigente_hasta, 'YYYY-MM-DD');
      if (acceso.lunes) {
        this.selected_acceso_dias.push('lunes');
      }
      if (acceso.martes) {
        this.selected_acceso_dias.push('martes');
      }
      if (acceso.miercoles) {
        this.selected_acceso_dias.push('miercoles');
      }
      if (acceso.jueves) {
        this.selected_acceso_dias.push('jueves');
      }
      if (acceso.viernes) {
        this.selected_acceso_dias.push('viernes');
      }
      if (acceso.sabado) {
        this.selected_acceso_dias.push('sabado');
      }
      if (acceso.domingo) {
        this.selected_acceso_dias.push('domingo');
      }
    },
    autorizaciones_info(autorizaciones) {
      this.carrito_golf = autorizaciones.carrito_golf;
      this.vehiculo_residente = autorizaciones.vehiculo_residente;
      this.vehiculo_particular = autorizaciones.vehiculo_particular;
      this.bicicleta = autorizaciones.bicicleta;
      this.motocicleta = autorizaciones.motocicleta;
      this.carrito_golf_detalles = this.clear_null(autorizaciones.carrito_golf_detalles);
      this.vehiculo_residente_detalles = this.clear_null(autorizaciones.vehiculo_residente_detalles);
      this.vehiculo_particular_detalles = this.clear_null(autorizaciones.vehiculo_particular_detalles);
      this.bicicleta_detalles = this.clear_null(autorizaciones.bicicleta_detalles);
      this.motocicleta_detalles = this.clear_null(autorizaciones.motocicleta_detalles);
    },
    check_image() {
      const imageToShow = document.getElementById('imgRostro');
      imageToShow.src = 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      this.styleProgress = 'display: block';
      const formdata = new FormData();
      formdata.set('face', this.domestico_image.replace(/^data:(.*,)?/, ''));
      ApiService.setHeader();
      ApiService.post('accesos/face_validation', formdata)
        .then(({ data }) => {
          if (data.code === 0) {
            this.styleProgress = 'display: none';
            this.rostro = data.image;
            imageToShow.src = this.decode_base64(data.image);
            this.disabled_guardar = false;
          } else {
            this.textProgress = 'Error al validar rostro';
            this.colorProgress = 'error';
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    decode_base64(value) {
      let encoded = '';
      let extension = '';
      if (value !== null) {
        encoded = value;
        const check = encoded.charAt(0);
        if (check === '/') {
          extension = 'jpg';
        } else if (check === '/') {
          extension = 'png';
        } else extension = 'tiff';
      } else {
        extension = 'png';
        encoded = 'R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }

      return `data:image/${extension};base64,${encoded}`;
    },
    formatter_date(fecha, formato = 'DD-MM-YYYY') {
      return moment(fecha).format(formato);
    },
    formatter_time(hora, formato = 'HH:mm') {
      return moment(hora, 'HH:mm:ss').format(formato);
    },
    send_form() {
      if (this.processing === true) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.$store.commit('capturaDomesticos/startedDomesticoProcessing');
        const formdata = new FormData();
        formdata.set('nombres', this.clear_null(this.nombres));
        formdata.set('apellido_paterno', this.clear_null(this.apellido_paterno));
        formdata.set('apellido_materno', this.clear_null(this.apellido_materno));
        formdata.set('sexo', this.clear_null(this.sexo));
        formdata.set('fecha_nacimiento', this.clear_null(this.fecha_nacimiento));
        formdata.set('nacionalidad', this.clear_null(this.nacionalidad));
        formdata.set('originario', this.clear_null(this.originario));
        formdata.set('curp', this.clear_null(this.curp));
        formdata.set('estado_civil', this.clear_null(this.estado_civil));
        formdata.set('rfc', this.clear_null(this.rfc));
        formdata.set('n_seguridad_social', this.clear_null(this.n_seguridad_social));
        formdata.set('domicilio', this.clear_null(this.domicilio));
        formdata.set('colonia', this.clear_null(this.colonia));
        formdata.set('localidad', this.clear_null(this.localidad));
        formdata.set('estado', this.clear_null(this.estado));
        formdata.set('telefono', this.clear_null(this.telefono));
        formdata.set('celular', this.clear_null(this.celular));
        formdata.set('codigo_postal', this.clear_null(this.codigo_postal));
        formdata.set('emergencia_nombre', this.clear_null(this.emergencia_nombre));
        formdata.set('emergencia_telefono', this.clear_null(this.emergencia_telefono));
        formdata.set('emergencia_parentesco', this.clear_null(this.emergencia_parentesco));
        formdata.set('puesto', this.clear_null(this.puesto));
        formdata.set('status', this.clear_null(this.status));
        formdata.set('motivo_baja', this.clear_null(this.motivo_baja));
        if (typeof this.vivienda_asoc === 'object' && this.clear_null(this.vivienda_asoc) !== '') {
          formdata.set('vivienda_id', this.vivienda_asoc.id);
        } else {
          formdata.set('vivienda_id', this.clear_null(this.vivienda_asoc));
        }
        formdata.set('residente_id', this.residentes_asoc);
        const tmpUso = {
          carrito_golf: this.change_boolean(this.carrito_golf),
          vehiculo_residente: this.change_boolean(this.vehiculo_residente),
          vehiculo_particular: this.change_boolean(this.vehiculo_particular),
          bicicleta: this.change_boolean(this.bicicleta),
          motocicleta: this.change_boolean(this.motocicleta),
          carrito_golf_detalles: this.clear_null(this.carrito_golf_detalles),
          bicicleta_detalles: this.clear_null(this.bicicleta_detalles),
          vehiculo_residente_detalles: this.clear_null(this.vehiculo_residente_detalles),
          vehiculo_particular_detalles: this.clear_null(this.vehiculo_particular_detalles),
          motocicleta_detalles: this.clear_null(this.motocicleta_detalles),
        };
        formdata.set('autorizaciones', JSON.stringify(tmpUso));
        const tmpAcceso = {
          todo_dia: this.change_boolean(this.tipo_horario),
          acceso_multiple: this.change_boolean(this.acceso_multiple),
          fecha_inicio: this.clear_null(this.fecha_inicio),
          fecha_fin: this.clear_null(this.fecha_fin),
          hora_entrada: this.clear_null(this.hora_entrada),
          hora_salida: this.clear_null(this.hora_salida),
          lunes: this.change_boolean(this.selected_acceso_dias.includes('lunes')),
          martes: this.change_boolean(this.selected_acceso_dias.includes('martes')),
          miercoles: this.change_boolean(this.selected_acceso_dias.includes('miercoles')),
          jueves: this.change_boolean(this.selected_acceso_dias.includes('jueves')),
          viernes: this.change_boolean(this.selected_acceso_dias.includes('viernes')),
          sabado: this.change_boolean(this.selected_acceso_dias.includes('sabado')),
          domingo: this.change_boolean(this.selected_acceso_dias.includes('domingo')),
        };
        formdata.set('acceso', JSON.stringify(tmpAcceso));
        formdata.set('faciales', JSON.stringify(this.selected_faciales));
        if (this.rostro.length !== 0) {
          formdata.set('rostro', this.rostro);
        }
        if (this.ine_frente.length !== 0) {
          if (this.ine_frente.includes('base64')) {
            formdata.set('ine_frente', this.ine_frente.split(',')[1]);
          } else {
            formdata.set('ine_frente', this.ine_frente);
          }
        }
        if (this.ine_reverso.length !== 0) {
          if (this.ine_reverso.includes('base64')) {
            formdata.set('ine_reverso', this.ine_reverso.split(',')[1]);
          } else {
            formdata.set('ine_reverso', this.ine_reverso);
          }
        }
        if (this.firma_residente.length !== 0) {
          formdata.set('firma_residente', this.firma_residente[this.firma_residente.length - 1]);
        }
        if (this.firma_domestico.length !== 0) {
          formdata.set('firma_domestico', this.firma_domestico[this.firma_domestico.length - 1]);
        }
        if (this.editdomestico) {
          formdata.set('domestico_id', this.domestico_info.id);
        }

        console.log(Object.fromEntries(formdata));
        this.$store.commit('capturaDomesticos/resetDomesticoSubmit');
        if (this.editdomestico) {
          this.$store.dispatch('capturaDomesticos/editDomestico', formdata).then(() => {
            this.$router.back();
          });
        } else {
          this.$store.dispatch('capturaDomesticos/sendDomestico', formdata).then(() => {
            this.$router.back();
          });
        }
      }
    },
    init_edit_data(data) {
      this.domestico_id = data.id;
      //this.residentes_asoc = data.residente_id;
      //this.vivienda_asoc = data.vivienda_id;
      this.nombres = data.nombres;
      this.apellido_paterno = data.apellido_paterno;
      this.apellido_materno = data.apellido_materno;
      this.sexo = data.sexo;
      this.fecha_nacimiento = this.clear_null(data.fecha_nacimiento);
      this.nacionalidad = data.nacionalidad;
      this.originario = data.originario;
      this.estado_civil = data.estado_civil;
      this.rfc = data.rfc;
      this.curp = data.curp;
      this.n_seguridad_social = data.n_seguridad_social;
      this.domicilio = data.domicilio;
      this.colonia = data.colonia;
      this.localidad = data.localidad;
      this.estado = data.estado;
      this.codigo_postal = data.codigo_postal;
      this.telefono = data.telefono;
      this.celular = data.celular;
      this.emergencia_nombre = data.emergencia_nombre;
      this.emergencia_telefono = data.emergencia_telefono;
      this.emergencia_parentesco = data.emergencia_parentesco;
      this.puesto = data.puesto;
      this.motivo_baja = data.motivo_baja;
      this.status = data.status;
      this.selected_faciales = data.faciales;
      this.autorizaciones_info(data.autorizaciones);
      if (data.vivienda_id !== null) {
        this.vivienda_asoc_info(data.vivienda_id);
        this.residente_asoc_info(data.residente_id);
        this.acceso_info(data.acceso);
      }
      if (this.status === 'inactivo') {
        this.motivo_disabled = false;
      } else {
        this.motivo_disabled = true;
      }
      if (this.status === 'inactivo') {
        this.motivo_disabled = false;
      } else {
        this.motivo_disabled = true;
      }
      if (data.foto_b64 !== null) {
        this.rostro = data.foto_b64;
        const imageToShow = document.getElementById('imgRostro');
        imageToShow.src = this.decode_base64(data.foto_b64);
      }
      if (data.ine_frente_b64 !== null) {
        this.ine_frente = data.ine_frente_b64;
        const imageToShow = document.getElementById('imgIneFrente');
        imageToShow.src = this.decode_base64(data.ine_frente_b64);
      }
      if (data.ine_reverso_b64 !== null) {
        this.ine_reverso = data.ine_reverso_b64;
        const imageToShow = document.getElementById('imgIneReverso');
        imageToShow.src = this.decode_base64(data.ine_reverso_b64);
      }
      // console.log(data);
    },
  },
  created() {
  },
  mounted() {
    if ('id' in this.$route.params) {
      this.$store.dispatch('capturaDomesticos/fetchDomesticoInfo', this.$route.params.id).then((data) => {
        this.domestico_info = data;
        this.init_edit_data(data);
      });
      this.editdomestico = true;
      this.disabled_guardar = false;
    }
  },
};
</script>
<style type="text/css">

</style>
